import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OpenDataIndicator } from '../../../interfaces/OpenData';
import { Pagination } from '../../../interfaces/Pagination';
import { getDatasetCount, getIndicators, getSearchOfIndicators } from './openDataThunk';
import { SearchOfIndicators } from '../../../interfaces/Rights';

interface OpenDataState {
    loadingSearch: boolean;
    loading: boolean;
    loadingDataset: boolean;
    indicators: OpenDataIndicator[];
    search: SearchOfIndicators[] | null;
    searchValue: string;
    errors_indicators: boolean;
    errors_search: string | null;
    pagination: Pagination;
    count_dataset: number;
}

const initialState: OpenDataState = {
    loading: true,
    loadingSearch: false,
    loadingDataset: false,
    indicators: [],
    search: null,
    searchValue: "",
    errors_indicators: false,
    errors_search: null,
    pagination: { totalItems: 0, currentPage: 1, pageSize: 10, totalPages: 0 },
    count_dataset: Number(localStorage.getItem('open_data_total_count')) || 0,
};

export const openDataSlice = createSlice({
    name: 'openData',
    initialState,
    reducers: {
        cleanSearch: (state) => {
            state.errors_search = null;
            state.search = null;
        },
        setSearchValue: (state, action: PayloadAction<string>) => {
            state.searchValue = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getIndicators.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getIndicators.fulfilled, (state, action) => {
            state.indicators = action.payload.indicators;
            state.pagination = action.payload.pagination;
            state.errors_indicators = action.payload.error!;
            state.loading = false;
        });
        builder.addCase(getIndicators.rejected, (state) => {
            state.loading = false;
            state.errors_indicators = true;
        });

        builder.addCase(getSearchOfIndicators.pending, (state) => {
            state.loadingSearch = true;
        });
        builder.addCase(getSearchOfIndicators.fulfilled, (state, action) => {
            state.loadingSearch = false;
            state.search = action.payload.search?.map(el => ({
                titulo: el.titulo,
                subdimension: el.breadcrumbs,
                id: el.id,
                breadcrumbs: el.breadcrumbs,
            })) || null;
            state.errors_search = action.payload.search?.length ? null : 'No se encontraron indicadores.';
        });
        builder.addCase(getSearchOfIndicators.rejected, (state, action) => {
            state.errors_search = action.error.message || 'Error al buscar';
            state.loadingSearch = false;
        });
        builder.addCase(getDatasetCount.pending, (state) => {
            state.loadingDataset = true;
        });
        builder.addCase(getDatasetCount.fulfilled, (state, action) => {
            state.loadingDataset = false;
            state.count_dataset = action.payload;
        });
        builder.addCase(getDatasetCount.rejected, (state) => {
            state.loadingDataset = false;
            state.count_dataset = 0;
        });
    },
});

export const { cleanSearch, setSearchValue } = openDataSlice.actions;
export default openDataSlice.reducer;